/**
 * Activity Log export column headers (must match backend registry).
 */

export const ACTIVITY_LOG_EXPORT_COLUMN_HEADERS = [
  'Date/Time',
  'Activity Type',
  'Activity',
  'Performed By',
  'Device Name',
  'Device ID',
  'Reference ID',
  'Maintenance Type',
  'Severity',
];

export const ACTIVITY_LOG_EXPORT_EXCEL_DEFAULT_HEADERS = new Set([
  'Date/Time',
  'Activity Type',
  'Activity',
  'Performed By',
  'Device Name',
  'Device ID',
]);

export const createActivityLogExportColumnsState = () =>
  ACTIVITY_LOG_EXPORT_COLUMN_HEADERS.reduce((acc, header) => {
    acc[header] = ACTIVITY_LOG_EXPORT_EXCEL_DEFAULT_HEADERS.has(header);
    return acc;
  }, {});

export const getSelectedExportColumnHeaders = (exportColumns) =>
  Object.entries(exportColumns)
    .filter(([, enabled]) => enabled !== false)
    .map(([header]) => header);
